import "core-js/modules/es6.number.constructor";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getMangeList } from "@/api/management/staff";
import Staffing from "./staffing.vue"; //在编人员

import Hires from "./hires.vue"; //聘用人员

import Retire from "./retire"; //离休人员

import Retirement from "./retirement";
export default {
  name: "wageSearch",
  components: {
    Staffing: Staffing,
    Hires: Hires,
    Retire: Retire,
    Retirement: Retirement
  },
  data: function data() {
    return {
      loading: false,
      tableData: [],
      userType: "0",
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  mounted: function mounted() {
    this.getTableData();
  },
  methods: {
    getTableData: function () {
      var _getTableData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, _yield$getMangeList, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading = true;
                params = {
                  current: this.pageNum,
                  size: this.pageSize,
                  userType: Number(this.userType)
                };
                _context.next = 4;
                return getMangeList(params);

              case 4:
                _yield$getMangeList = _context.sent;
                data = _yield$getMangeList.data;
                this.loading = false;

                if (data.code == 0) {
                  this.tableData = data.data.records;
                  this.total = data.data.total;
                } else {
                  this.$message.error(data.msg);
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTableData() {
        return _getTableData.apply(this, arguments);
      }

      return getTableData;
    }(),
    handleClick: function handleClick() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    // 条数
    changeSize: function changeSize(value) {
      this.pageSize = value;
      this.getTableData();
    },
    // 上下页
    changePage: function changePage(value) {
      this.pageNum = value;
      this.getTableData();
    }
  }
};